export default __webpack_public_path__ + "c59942dc37775f047b78a37bc483457a.png";